import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';

// Campos customizados do Scaffolder usados pelos templates
// "Aplicação genérica completa" (ver
// content/catalog/templates/generic-app-completo/template.yaml).
const dockerfileInput = FormFieldBlueprint.make({
  name: 'dockerfile-input',
  params: {
    field: () => import('./fields').then(m => m.dockerfileInputField),
  },
});

const dockerfilePort = FormFieldBlueprint.make({
  name: 'dockerfile-port',
  params: {
    field: () => import('./fields').then(m => m.dockerfilePortField),
  },
});

const domainPicker = FormFieldBlueprint.make({
  name: 'domain-picker',
  params: {
    field: () => import('./fields').then(m => m.domainPickerField),
  },
});

const subdomainInput = FormFieldBlueprint.make({
  name: 'subdomain-input',
  params: {
    field: () => import('./fields').then(m => m.subdomainInputField),
  },
});

const nodePortInput = FormFieldBlueprint.make({
  name: 'nodeport-input',
  params: {
    field: () => import('./fields').then(m => m.nodePortInputField),
  },
});

// Campos "valor sugerido" (etapa Catálogo do template completo).
const suggestedTags = FormFieldBlueprint.make({
  name: 'suggested-tags',
  params: {
    field: () => import('./suggestedFields').then(m => m.suggestedTagsField),
  },
});

const suggestedText = FormFieldBlueprint.make({
  name: 'suggested-text',
  params: {
    field: () => import('./suggestedFields').then(m => m.suggestedTextField),
  },
});

const suggestedChoice = FormFieldBlueprint.make({
  name: 'suggested-choice',
  params: {
    field: () => import('./suggestedFields').then(m => m.suggestedChoiceField),
  },
});

const dockerfileSuggestionsSummary = FormFieldBlueprint.make({
  name: 'dockerfile-suggestions-summary',
  params: {
    field: () => import('./suggestedFields').then(m => m.dockerfileSuggestionsSummaryField),
  },
});

export const scaffolderFieldsModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    dockerfileInput,
    dockerfilePort,
    nodePortInput,
    domainPicker,
    subdomainInput,
    suggestedTags,
    suggestedText,
    suggestedChoice,
    dockerfileSuggestionsSummary,
  ],
});
